<!--components/uploadPic/index.wxml-->
<template>
  <div class="uploadPic">
    <van-uploader v-model="imageUrlList" :after-read="afterRead" :before-delete="handleDelete" :max-count="9"
      :max-size="1024 * 5 * 1024" @oversize="onOversize">
      <van-button class="pic addPic" icon="plus" type="primary" />
    </van-uploader>
  </div>

</template>

<script>
import Vue from 'vue';
import axios from 'axios';
import { Uploader, Toast, Button } from 'vant';
Vue.use(Uploader);
Vue.use(Button);

export default {
  name: "UploadPic",
  props: {
    max: {
      type: Number,
      default: 9,
    },
  },
  components: {},
  data () {
    return {
      imageUrlList: [], //图片列表
      imagesList: [] // 保存图片
    };
  },
  watch: {},
  computed: {},
  methods: {
    // 上传
    afterRead (e, name) {
      let file = e.file
      e.status = 'uploading';
      e.message = '上传中...';
      let formData = new FormData();
      formData.append('file', file);
      let host = process.env.VUE_APP_PAY_API_URL
      axios.post(`${host}/UploadFile/UploadAliyunFile`, formData, { headers: { 'Content-Type': 'multipart/form-data' } }).then((response) => {
        let url = response.data.result.FileUrl;
        this.imagesList.push(url)
        this.$emit('getCheageDelete', this.imagesList)
        setTimeout(() => {
          e.status = 'done';
          e.message = '上传成功';
        }, 500);
      }).catch((error) => {
        console.log(error);
        setTimeout(() => {
          e.status = 'failed';
          e.message = '上传失败';
        }, 500);
      });
    },
    // 删除
    handleDelete (e, name) {
      let index = name.index
      let imagesList = this.imagesList;
      imagesList.splice(index, 1)
      this.imagesList = imagesList
      this.$emit('getCheageDelete', imagesList)
      return (file, index) => { }
    },
    onOversize (file) {
      console.log(file);
      Toast('图片大小不超过5MB');
    },
    handleDelPic () {
      console.log(e)
    },
    handleAddPic () {
      if (this.imageUrlList.length >= this.max) {
        //getApp().showToastGlob(`最多上传${this.max}张`, 'none', 1500)
        return;
      }
      let imageUrlList = this.imageUrlList;
      imageUrlList.push(
        "http://www.yuanling.gov.cn/yuanling/c121531/202103/05d111286285453aa9e4e43cece729b9/images/57cf2924f49a43cea53d0a3ceddbd957.jpg"
      );
      this.imageUrlList = imageUrlList
    },
  },
  mounted () {

  },
  created () { },
};
</script>

<style lang="less" scoped>
/* components/uploadPic/index.wxss */
.addPic {
  width: 160px;
  height: 160px;
  background: #f7f7f7;
  border: 2px solid #e1e1e1;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 16px;
}

.uploadPic {
  display: flex;
  flex-wrap: wrap;
}

.uploadPic .van-button__icon {
  color: #CCCCCC;
  font-size: 60px;
  font-weight: bold;
}

.uploadPic .pic img {
  width: 144px;
  height: 144px;
}

.uploadPic .addPic img {
  width: 52px;
  height: 52px;
}

.uploadPic .pic {
  position: relative;
  margin-right: 26px;
}

.uploadPic .pic img.delPic {
  width: 32px;
  height: 32px;
  position: absolute;
  right: -15px;
  top: -15px;
}
</style>
